<template>
    <v-app>
        <v-app-bar
        app
        color="white"
        height="100"
        >
            <v-avatar
                class="mr-3 pa-2"
                size="70"
            >
                <v-img
                    contain
                    max-height="100%"
                    src="@/assets/icon.png"
                ></v-img>
            </v-avatar>

            <h1 class="display-2 font-weight-black text-decoration-overline">CODE IN CODE</h1>

            <v-spacer></v-spacer>
        </v-app-bar>

        <v-main>
            <router-view/>
        </v-main>
    </v-app>
</template>

<script>

export default {
    name: 'App',

    data: () => ({
        //
    }),
}
</script>
